import FirebaseInstallSnippet from "snippets/e3kit/custom/install";
import FirebaseInitializeSnippet from "snippets/e3kit/firebase/initialize";
import * as React from 'react';
export default {
  FirebaseInstallSnippet,
  FirebaseInitializeSnippet,
  React
};